import { render } from "./chatList.vue?vue&type=template&id=fcff6024&scoped=true"
import script from "./chatList.vue?vue&type=script&lang=js"
export * from "./chatList.vue?vue&type=script&lang=js"

import "./chatList.vue?vue&type=style&index=0&id=fcff6024&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcff6024"]])

export default __exports__